import { useEffect, useState, type PropsWithChildren, type ReactNode } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $dashboardNotificationStore, $profileFeatureStore } from '@lib/store';
import { useDocumentTitle } from '@shared/hooks';
import { cn, PaletteUtils } from '@shared/utils';
import { Footer, Header, Sidebar } from '@widgets';

type PageContainerProps = {
  className?: string;
  title?: string;
  return?: boolean;
  back?: boolean;
  backText?: string;
  to?: string | null;
  header?: ReactNode;
  showProfileName?: boolean;
  topRightAddons?: ReactNode;
} & PropsWithChildren;

export const PageContainer = (props: PageContainerProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const [showMobileMenu, setShowMobileMenu] = useState<boolean>(false);

  const { t } = useTranslation();
  useDocumentTitle(props.title ?? t('title'));

  useEffect(() => {
    if (profileFeatureStore.data?.settings?.viewNotifications) $dashboardNotificationStore.events.getAll();
  }, [profileFeatureStore.data?.settings?.viewNotifications]);

  return (
    <div className='flex h-screen min-h-screen w-screen'>
      <Sidebar open={showMobileMenu} onClose={() => setShowMobileMenu(false)} />
      <div className='flex h-screen min-h-screen flex-1 flex-col overflow-hidden'>
        <Header
          return={props.return}
          back={props.back}
          backText={props.backText}
          to={props.to}
          header={props.header}
          showProfileName={props.showProfileName}
          topRightAddons={props.topRightAddons}
          onShowMobileMenu={() => setShowMobileMenu(true)}
        />
        <div
          className={cn(
            'flex h-[calc(100vh-71px)] w-full flex-col overflow-y-auto',
            'max-md:h-full',
            PaletteUtils.isVcfcPalette && 'bg-ghost-white dark:bg-eerie-black',
          )}
        >
          <main
            className={cn(
              'w-full',
              'max-md:px-4',
              PaletteUtils.isInsigniaPalette && 'p-8',
              PaletteUtils.isVcfcPalette && 'px-10 pb-4 pt-6',
              props.className,
            )}
          >
            {props.children}
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
};
